// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import {
  Dropdown,
  Modal,
  Tabs,
  Popover,
  Toggle,
  Slideover,
} from "tailwindcss-stimulus-components";
application.register("dropdown", Dropdown);
application.register("modal", Modal);
application.register("tabs", Tabs);
application.register("popover", Popover);
application.register("toggle", Toggle);
application.register("slideover", Slideover);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import MenuController from "./menu_controller";
application.register("menu", MenuController);

import NotificationsController from "./notifications_controller";
application.register("notifications", NotificationsController);

import ParameterizeController from "./parameterize_controller";
application.register("parameterize", ParameterizeController);

import ValidateController from "./validate_controller";
application.register("validate", ValidateController);

import NestedFormController from "./nested_form_controller";
application.register("nested-form", NestedFormController);

import ReorderController from "./reorder_controller";
application.register("reorder", ReorderController);

import toggled_controller from "./toggled_controller";
application.register("toggled", toggled_controller);

import asset_editor_controller from "./asset_editor_controller";
application.register("asset-editor", asset_editor_controller);

import picker_controller from "./picker_controller";
application.register("picker", picker_controller);

import video_controller from "./video_controller";
application.register("video", video_controller);

import new_template_controller from "./new_template_controller";
application.register("new-template", new_template_controller);

import template_editor_controller from "./template_editor_controller";
application.register("template-editor", template_editor_controller);

import dropdown_menu_controller from "./dropdown_menu_controller";
application.register("dropdown-menu", dropdown_menu_controller);

import clipboard_controller from "./clipboard_controller";
application.register("clipboard", clipboard_controller);
